import React, { useState } from "react";
import { ModalComponent, ToastMessage } from "components";
// eslint-disable-next-line import/no-cycle
import CreateSupplier from "./createSupplier";

function CreateSupplierModal({
    showSupplierModal,
    handleCloseSupplierModal,
    setShowSupplierModal,
    setIsSupplierDataChange,
}) {
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [supplierName, setSupplierName] = useState(null);
    const onSuccess = (supplierName) => {
        setShowSupplierModal(false);
        setSupplierName(supplierName);
        setShowSuccessMessage(true);
    };
    return (
        <>
            <ModalComponent
                open={showSupplierModal}
                size="large"
                header="New Supplier"
                borderedHeader
                onClose={handleCloseSupplierModal}
            >
                <CreateSupplier
                    onClose={handleCloseSupplierModal}
                    showSuccessMessage={showSuccessMessage}
                    setShowSuccessMessage={setShowSuccessMessage}
                    setIsSupplierDataChange={setIsSupplierDataChange}
                    onSuccess={onSuccess}
                />
            </ModalComponent>
            {showSuccessMessage && (
                <ToastMessage
                    type="success"
                    showToast={showSuccessMessage}
                    setShowToast={setShowSuccessMessage}
                    name={supplierName}
                    text="has been created successfully and is pending
                    verification."
                />
            )}
        </>
    );
}

export default CreateSupplierModal;
